import { render, staticRenderFns } from "./ConfigEarlyLeftWarning.vue?vue&type=template&id=287a5cb4&scoped=true"
import script from "./ConfigEarlyLeftWarning.vue?vue&type=script&lang=ts"
export * from "./ConfigEarlyLeftWarning.vue?vue&type=script&lang=ts"
import style0 from "./ConfigEarlyLeftWarning.vue?vue&type=style&index=0&id=287a5cb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287a5cb4",
  null
  
)

export default component.exports